import type { Lucid } from '../../types/types';

// The `locale_id` value must match the value that is returned from Smartling
// Example: https://dashboard.smartling.com/app/projects/<project_id>/project-settings/languages.html

export const languagesDirectus: Lucid.I18n.DirectusLanguage[] = [
  {
    display_name: 'Danish',
    locale_id: 'da', // The Smartling Locale ID
    url_lang_prefix: '/da',
    short_code: 'da',
    name: 'Dansk',
    english_name: 'Danish',
    drupal_lang_id: 'DA',
    code: 'da-DA',
  },
  {
    display_name: 'German',
    locale_id: 'de', // The Smartling Locale ID
    url_lang_prefix: '/de',
    short_code: 'de',
    name: 'Deutsch',
    english_name: 'German',
    drupal_lang_id: 'DE',
    code: 'de-DE',
  },
  {
    display_name: 'English',
    locale_id: 'en-US', // The Smartling Locale ID (Not In Smartling)
    url_lang_prefix: null,
    short_code: 'en',
    name: 'English',
    english_name: 'English',
    drupal_lang_id: 'EN',
    code: 'en-US',
  },
  {
    display_name: 'Spanish',
    locale_id: 'es-LA', // The Smartling Locale ID
    url_lang_prefix: '/es',
    short_code: 'es',
    name: 'Español',
    english_name: 'Spanish',
    drupal_lang_id: 'ES',
    code: 'es-LA',
  },
  {
    display_name: 'French',
    locale_id: 'fr-FR', // The Smartling Locale ID
    url_lang_prefix: '/fr',
    short_code: 'fr',
    name: 'Français',
    english_name: 'French',
    drupal_lang_id: 'FR',
    code: 'fr-FR',
  },
  {
    display_name: 'Italian',
    locale_id: 'it-IT', // The Smartling Locale ID
    url_lang_prefix: '/it',
    short_code: 'it',
    name: 'Italiano',
    english_name: 'Italian',
    drupal_lang_id: 'IT',
    code: 'it-IT',
  },
  {
    display_name: 'Japanese',
    locale_id: 'ja', // The Smartling Locale ID
    url_lang_prefix: '/ja',
    short_code: 'ja',
    name: '日本語',
    english_name: 'Japanese',
    drupal_lang_id: 'JA',
    code: 'ja-JA',
  },
  {
    display_name: 'Korean',
    locale_id: 'ko', // The Smartling Locale ID
    url_lang_prefix: '/ko',
    short_code: 'ko',
    name: '한국인',
    english_name: 'Korean',
    drupal_lang_id: 'KO',
    code: 'ko-KO',
  },
  {
    display_name: 'Dutch',
    locale_id: 'nl', // The Smartling Locale ID
    url_lang_prefix: '/nl',
    short_code: 'nl',
    name: 'Nederlands',
    english_name: 'Dutch',
    drupal_lang_id: 'NL',
    code: 'nl-NL',
  },
  {
    display_name: 'Polish',
    locale_id: 'pl-PL', // The Smartling Locale ID
    url_lang_prefix: '/pl',
    short_code: 'pl',
    name: 'Polski',
    english_name: 'Polish',
    drupal_lang_id: 'PL',
    code: 'pl-PL',
  },
  {
    display_name: 'Portuguese',
    locale_id: 'pt-BR', // The Smartling Locale ID
    url_lang_prefix: '/pt',
    short_code: 'pt',
    name: 'Português',
    english_name: 'Portuguese',
    drupal_lang_id: 'PT_BR',
    code: 'pt-BR',
  },
  {
    display_name: 'Russian',
    locale_id: 'ru', // The Smartling Locale ID
    url_lang_prefix: '/ru',
    short_code: 'ru',
    name: 'Pусский',
    english_name: 'Russian',
    drupal_lang_id: 'RU',
    code: 'ru-RU',
  },
  {
    display_name: 'Swedish',
    locale_id: 'sv-SE', // The Smartling Locale ID
    url_lang_prefix: '/sv',
    short_code: 'sv',
    name: 'Svenska',
    english_name: 'Swedish',
    drupal_lang_id: 'SV',
    code: 'sv-SE',
  },
];

const languages: Lucid.I18n.Languages = {
  en: {
    name: 'English',
    englishName: 'English',
    shortLangPrefix: 'en',
    i18nKey: 'en',
    urlLangPrefix: '',
    languageId: 'EN',
    languageKey: 'en',
    languageCode: 'en-US',
  },
  fr: {
    name: 'Français',
    englishName: 'French',
    shortLangPrefix: 'fr',
    i18nKey: 'fr-FR',
    urlLangPrefix: 'fr/',
    languageId: 'FR',
    languageKey: 'fr',
    languageCode: 'fr-FR',
  },
  de: {
    name: 'Deutsch',
    englishName: 'German',
    shortLangPrefix: 'de',
    i18nKey: 'de',
    urlLangPrefix: 'de/',
    languageId: 'DE',
    languageKey: 'de',
    languageCode: 'de-DE',
  },
  ja: {
    name: '日本語',
    englishName: 'Japanese',
    shortLangPrefix: 'ja',
    i18nKey: 'ja',
    urlLangPrefix: 'ja/',
    languageId: 'JA',
    languageKey: 'ja',
    languageCode: 'ja-JA',
  },
  'pt-br': {
    name: 'Português',
    englishName: 'Portuguese',
    shortLangPrefix: 'pt',
    i18nKey: 'pt-BR',
    urlLangPrefix: 'pt/',
    languageId: 'PT_BR',
    languageKey: 'pt-br',
    languageCode: 'pt-BR',
  },
  es: {
    name: 'Español',
    englishName: 'Spanish',
    shortLangPrefix: 'es',
    i18nKey: 'es-LA',
    urlLangPrefix: 'es/',
    languageId: 'ES',
    languageKey: 'es',
    languageCode: 'es-LA',
  },
  nl: {
    name: 'Nederlands',
    englishName: 'Dutch',
    shortLangPrefix: 'nl',
    i18nKey: 'nl',
    urlLangPrefix: 'nl/',
    languageId: 'NL',
    languageKey: 'nl',
    languageCode: 'nl-NL',
  },
  da: {
    name: 'Dansk',
    englishName: 'Danish',
    shortLangPrefix: 'da',
    i18nKey: 'da',
    urlLangPrefix: 'da/',
    languageId: 'DA',
    languageKey: 'da',
    languageCode: 'da-DA',
  },
  sv: {
    name: 'Svenska',
    englishName: 'Swedish',
    shortLangPrefix: 'sv',
    i18nKey: 'sv-SE',
    urlLangPrefix: 'sv/',
    languageId: 'SV',
    languageKey: 'sv',
    languageCode: 'sv-SE',
  },
  ru: {
    name: 'Pусский',
    englishName: 'Russian',
    shortLangPrefix: 'ru',
    i18nKey: 'ru',
    urlLangPrefix: 'ru/',
    languageId: 'RU',
    languageKey: 'ru',
    languageCode: 'ru-RU',
  },
  it: {
    name: 'Italiano',
    englishName: 'Italian',
    shortLangPrefix: 'it',
    i18nKey: 'it-IT',
    urlLangPrefix: 'it/',
    languageId: 'IT',
    languageKey: 'it',
    languageCode: 'it-IT',
  },
  ko: {
    name: '한국인',
    englishName: 'Korean',
    shortLangPrefix: 'ko',
    i18nKey: 'ko',
    urlLangPrefix: 'ko/',
    languageId: 'KO',
    languageKey: 'ko',
    languageCode: 'ko-KO',
  },
  pl: {
    name: 'Polski',
    englishName: 'Polish',
    shortLangPrefix: 'pl',
    i18nKey: 'pl-PL',
    urlLangPrefix: 'pl/',
    languageId: 'PL',
    languageKey: 'pl',
    languageCode: 'pl-PL',
  },
};

export default languages;
